module.exports = __webpack_public_path__ + "img/quantity.0d51da9d.svg";